module.exports = __webpack_public_path__ + "img/foot1.c66727a9.png";